import { config, toRootMargin } from './config.js';

/**
 * Create an IntersectionObserver that fires callback once per element.
 * Falls back to immediate execution when IntersectionObserver is unavailable.
 *
 * @param {Function} callback - receives the intersecting HTMLElement
 * @returns {IntersectionObserver|{ observe: Function }}
 */
export function createObserver(callback) {
  if (!('IntersectionObserver' in window)) {
    return { observe: (el) => callback(el) };
  }

  return new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        callback(entry.target);
        obs.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: toRootMargin(config.threshold),
  });
}
